import React, { PropTypes } from 'react';
import IconButton from 'material-ui/IconButton';
import { IconDelete } from '../Icons';
import TextField from 'material-ui/TextField';
import { CollapseContainer } from '../Collapse';
import HardwareKeyboardArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import HardwareKeyboardArrowUp from 'material-ui/svg-icons/hardware/keyboard-arrow-up';

export const HeaderOnePropTypes = {
  onChangeLabel: PropTypes.func.isRequired,
  canDelete: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};

export class ClubCmsHeader extends React.Component {
  static propTypes = Object.assign({}, HeaderOnePropTypes, {
    remove: PropTypes.func.isRequired,
    open: PropTypes.bool,
    toggleView: PropTypes.func
  });

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  state = {
    hover: false
  };

  render() {
    let {
      canDelete,
      color,
      label,
      onChangeLabel,
      remove,
      open,
      toggleView
    } = this.props;

    let { hover } = this.state;

    let headerStyle = {
      backgroundColor: color,
      paddingLeft: 16,
      paddingRight: 16,
      display: 'flex',
      justifyContent: 'space-between'
    };

    return (
    <div style={headerStyle} onMouseEnter={()=> this.setState({hover: true})} onMouseLeave={()=> this.setState({hover: false})}>
      <div style={{display: 'flex', justifyContent: 'flex-start'}}>
        <div>
          <TextField
            name="label"
            onChange={(event) => onChangeLabel(event.target.value)}
            value={label}
            inputStyle={{color: 'white'}}
          />
        </div>
        <div style={{display: !hover ? 'none' : null}}>
          <IconButton onClick={remove} disabled={!canDelete} style={{display: !canDelete ? 'none' : null}}><IconDelete
            color="white"/></IconButton>
        </div>
      </div>
      <div>
        {toggleView
          ? (
            <IconButton onClick={toggleView}>
              {open
                ? <HardwareKeyboardArrowUp color="white"/>
                : <HardwareKeyboardArrowDown color="white"/>
              }
            </IconButton>
          )
          : null
        }
      </div>
    </div>
  )
    ;
  }
}

ClubCmsHeader.defaultProps = {
  canDelete: false,
  addHeaderTwoTitle: 'Add Title',
  color: 'gray'
};


class ClubCmsHeaderWithContent extends React.Component {
  static propTypes = Object.assign({}, HeaderOnePropTypes, {
    children: PropTypes.node.isRequired
  });

  state = {
    open: true
  };

  _toggleCollapse = () => {
    this.setState({open: !this.state.open});
  };

  render() {
    let { children, ...other } = this.props;
    let { open } = this.state;

    return (
      <div>
        <ClubCmsHeader toggleView={() => this._toggleCollapse()} open={open} {...other}/>
        <CollapseContainer open={open}>
          {children}
        </CollapseContainer>
      </div>
    );
  }
}

export default ClubCmsHeaderWithContent;




// WEBPACK FOOTER //
// ./src/components/ClubCMS/ClubCmsHeader.js